(function () {
  const STORAGE_KEY = "SapyenCart";

  function load() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  }

  function save(items) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items)
    );
  }

  const items = load();

  window.SapyenCart = {
    items,

    add(key, item) {
      this.items[key] = item;
      save(this.items);
    },

    update(key, updates) {
      if (!this.items[key]) return;

      this.items[key] = {
        ...this.items[key],
        ...updates,
        properties: {
          ...(this.items[key].properties || {}),
          ...(updates.properties || {})
        }
      };

      save(this.items);
    },

    remove(key) {
      delete this.items[key];
      save(this.items);
    },

    get(key) {
      return this.items[key];
    },

    has(key) {
      return !!this.items[key];
    },

    getItems() {
      return Object.values(this.items);
    },

    clear() {
      this.items = {};
      sessionStorage.removeItem(STORAGE_KEY);
    },

    log() {
      console.log("Cart Item fetched");
    }
  };
})();